import { Tabs } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const DosageModal = ({ cropName, modalId }) => {
  const { data: crop } = useSelector((state) => state?.targetCropConcern || {});
  const [filter, setFilter] = useState();

  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="staticBackdrop"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header bg-gray-700">
            <h5
              className="modal-title text-white text-capitalize"
              id="usage-modal"
            >
              {cropName}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() =>
                  setFilter()
              }
            >
              <i aria-hidden="true" className="ki ki-close text-white"></i>
            </button>
          </div>
          <div
            className="modal-body pt-0"
            style={{
              maxHeight: 500 + "px",
            }}
          >
            <Tabs
              defaultActiveKey="1"
              items={[
                {
                  key: "1",
                  label: "Dosage",
                  children:
                    crop?.dosages?.length > 0 ? (
                      <div className="main_tabs_area">
                        {/* Left List Start */}
                        <div className="left_tabs new-custom-radio-button">
                          {crop?.dosages?.map((dosage, index) => (
                            <ul
                              className="nav nav-tabs nav-tabs-line"
                              key={index.toString()}
                            >
                              <label className="status">
                                <input type="radio" name="radio-l" />
                                <div className="box">
                                  <span onClick={() => setFilter(dosage)}>
                                    {dosage?.lifecycleStage?.en}
                                  </span>
                                </div>
                              </label>
                            </ul>
                          ))}
                        </div>
                        {/* Left List End */}

                        <div className="inner_left_top">
                          {filter?.stageDosages?.map((dosageData, index) => (
                            <table
                              key={index.toString()}
                              className="table table-bordered mb-5 table-striped"
                              width="100%"
                            >
                              <thead className="text-white bg-gray-700">
                                <tr>
                                  <th colSpan={2}>
                                    {filter?.lifecycleStage?.en} <br />
                                    <small>{dosageData?.age?.en}</small>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="align-middle font-weight-bold">
                                    Application Method
                                  </td>
                                  <td className="font-weight-bold btn btn-sm btn-primary">
                                    {dosageData?.applicationMethod?.en}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="align-middle font-weight-bold">
                                    Dose
                                  </td>
                                  <td className="align-middle font-weight-bold">
                                    {dosageData?.dose?.max +
                                      dosageData?.dose?.unit}
                                  </td>
                                </tr>

                                {dosageData?.area && (
                                  <tr>
                                    <td className="align-middle font-weight-bold">
                                      Area
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                      {dosageData?.area?.area +
                                        dosageData?.area?.unit}
                                    </td>
                                  </tr>
                                )}

                                {dosageData?.solvent?.length > 0 && (
                                  <tr>
                                    <td className="align-middle font-weight-bold">
                                      Solvent
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                      {dosageData?.solvent?.map(
                                        (solvent, i) => (
                                          <span key={i}>
                                            ({solvent?.name?.en}) {solvent?.min}
                                            -{solvent?.max + solvent?.unit}
                                            <br />
                                          </span>
                                        )
                                      )}
                                    </td>
                                  </tr>
                                )}

                                {dosageData?.surfactant?.length > 0 && (
                                  <tr>
                                    <td className="align-middle font-weight-bold">
                                      Surfactant
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                      {dosageData?.surfactant?.map(
                                        (surfactant, i) => (
                                          <span key={i}>
                                            ({surfactant?.name?.en}){" "}
                                            {surfactant?.min}-
                                            {surfactant?.max + surfactant?.unit}
                                            <br />
                                          </span>
                                        )
                                      )}
                                    </td>
                                  </tr>
                                )}

                                {dosageData?.sefinar && (
                                  <tr>
                                    <td className="align-middle font-weight-bold">
                                      Sefinar
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                      {dosageData?.sefinar?.max +
                                        dosageData?.sefinar?.unit}
                                    </td>
                                  </tr>
                                )}

                                {dosageData?.sticker && (
                                  <tr>
                                    <td className="align-middle font-weight-bold">
                                      Sticker
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                      {dosageData?.sticker?.max +
                                        dosageData?.sticker?.unit}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p className="text-center">No Data Found</p>
                    ),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DosageModal;
